import { BusinessSchema } from '@40seas/entities/businesses';
import { EntityReference, EntityReferenceSchema, EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity, Currency, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { ConnectedAccountCurrencyConversionStatus } from './connected-account.currency-conversion.status.enum';
import { ProviderType } from './provider.type.enum';

export const ConnectedAccountCurrencyConversionSchema = WithBaseEntitySchema(
    z.object({
        rate: z.number().optional(),
        providerRate: z.number().optional(),
        from: EnumSchema(Currency),
        to: EnumSchema(Currency),
        amount: z.number().optional(),
        convertedAmount: z.number().optional(),
        status: EnumSchema(ConnectedAccountCurrencyConversionStatus),
        providerId: z.string().optional(),
        providerType: EnumSchema(ProviderType),
        entities: z.array(EntityReferenceSchema).optional(),
        seller: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            .or(BusinessSchema),
        feeDefinition: z.string().optional(),
    }),
).strict();

export class ConnectedAccountCurrencyConversion extends FromSchema(ConnectedAccountCurrencyConversionSchema) implements BaseEntity {
    id: string;
    rate?: number;
    providerRate?: number;
    from: Currency;
    to: Currency;
    amount?: number;
    convertedAmount?: number;
    status: ConnectedAccountCurrencyConversionStatus;
    providerId?: string;
    providerType: ProviderType;
    entities?: EntityReference[];
    feeDefinition?: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
